// extracted by mini-css-extract-plugin
export default {"formContainer":"formContainer_formContainer__AIRD4"};